import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import { toNumber } from 'lodash'
// import { dummyDataLengthByType, noDummyDataLengthByType } from './dummy_data'


import './table-length-by-type-dma.style.css';

export class TableLengthByTypeDMA extends Component {
    constructor(props) {
        super(props);

        this.state = {
            colums: [],
            products: []
        }
    }

    createCol = (dataLengthByType) => {
        try {
            if (Array.isArray(dataLengthByType) && dataLengthByType.length) {
                let oneObject = dataLengthByType[0];
                let arrayAllKey = Object.keys(oneObject);
                let arrayKeyDontUse = ['id', 'category', 'total'];
                let arrayUseKey = arrayAllKey.filter((element) => {
                    return !arrayKeyDontUse.includes(element)
                })
                let arrayColInfo = arrayUseKey.map((element) => {
                    return {
                        dataField: `${element}`, text: `${oneObject[element]['name']}`,
                        footer: columnData => columnData.reduce((acc, item) => (toNumber(acc) + toNumber(item)).toFixed(2), 0),
                        footerStyle: {
                            backgroundColor: '#D9FFF8'
                        }
                    }
                })

                arrayColInfo.unshift({
                    dataField: 'category', text: 'Category', footer: 'Total (km)',
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                arrayColInfo.unshift({
                    dataField: 'id', text: '#', footer: '-',
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                arrayColInfo.push({
                    dataField: 'total', text: 'Total (km)',
                    footer: columnData => columnData.reduce((acc, item) => (toNumber(acc) + toNumber(item)).toFixed(2), 0),
                    style: { backgroundColor: '#D9FFF8' },
                    headerStyle: {
                        backgroundColor: '#D9FFF8'
                    },
                    footerStyle: {
                        backgroundColor: '#D9FFF8'
                    }
                });
                // console.log('result: ', JSON.stringify(arrayColInfo))
                return arrayColInfo;
            } else {
                return []
            }
        } catch (error) {
            console.log('Error create column: ', error);
            return []
        }
    }

    transformObject = (objectSource) => {
        try {
            const tamp = ['id', 'category', 'total'];
            let newObject = {}
            for (let key in objectSource) {
                if (tamp.includes(key)) {
                    newObject[key] = objectSource[key];
                } else {
                    newObject[key] = objectSource[key].value;
                }
            }
            return newObject;
        } catch (error) {
            console.log('Error create product: ', error);
            return {}
        }
    }

    createProduct = (dataLengthByType) => {
        try {
            if (Array.isArray(dataLengthByType) && dataLengthByType.length) {
                let arrayProduct = dataLengthByType.map((element) => {
                    return this.transformObject(element);
                });
                // console.log('array product: ', arrayProduct);
                return arrayProduct;
            } else {
                return []
            }
        } catch (error) {
            console.log('Error create product: ', error);
            return []
        }
    }

    render() {
        const columns = this.createCol(this.props.dataLengthByType);
        const products = this.createProduct(this.props.dataLengthByType);

        if (Array.isArray(columns) && columns.length) {
            return (
                <div>
                    <BootstrapTable keyField='id' data={products} columns={columns} wrapperClasses="table-responsive" version='4' />
                </div>
            )
        }
        else {
            return (
                <div>

                </div>
            )
        }
    }
}

export default TableLengthByTypeDMA
